// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-types {\n  position: relative;\n}\n  .section-types .sections {\n    display: flex;\n    overflow: hidden;\n    padding-bottom: 8px;\n  }\n  .section-types .sections .section:not(:last-of-type) {\n      margin-right: 2px;\n    }\n", ""]);
// Exports
module.exports = exports;
